export default function updateSlidesOffset() {
  var swiper = this;
  var slides = swiper.slides;

  for (var i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}


//////////////////
// WEBPACK FOOTER
// /var/www/vhosts/pre-motion360.com/httpdocs/wp-content/themes/BOOOM/node_modules/swiper/esm/components/core/update/updateSlidesOffset.js
// module id = 23
// module chunks = 0